import PropTypes from 'prop-types'
import React from 'react'
import { Paper, Popper, ClickAwayListener } from '@mui/material'

const arrowAlignment = {
  center: {
    left: '50%',
    transform: 'translateX(-50%)'
  },
  right: {
    right: 0
  }
}

const arrowBaseStyle = {
  position: 'absolute',
  top: '-15px',
  borderLeft: '15px solid transparent',
  borderRight: '15px solid transparent',
  borderBottom: '15px solid white'
}

const Message = ({ anchorEl, onClose, arrowPosition, className, classes = {}, children }) => {
  return (
    <Popper open={Boolean(anchorEl)} className="z-10" anchorEl={anchorEl} disablePortal placement="bottom">
      <Paper className={className} sx={{ boxShadow: '4px 4px 20px 0px #555869', borderRadius: '10px' }}>
        <ClickAwayListener onClickAway={onClose}>
          <div className="relative">
            <span className={classes.arrow} style={{ ...arrowBaseStyle, ...arrowAlignment[arrowPosition] }} />
            <div className={classes.body}>{children}</div>
          </div>
        </ClickAwayListener>
      </Paper>
    </Popper>
  )
}

export default Message

Message.propTypes = {
  anchorEl: PropTypes.element,
  arrowPosition: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object,
  onClose: PropTypes.func
}
